import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import theme from '../../../../themes/default';
import Typography from '@material-ui/core/Typography';
import { LETTERS, NUMBERS, MAX_SECRET_CODE_WIDTH } from '../constants';

import { getSecretCode, getLettercardRow } from './helpers';

const useStyles = makeStyles<Theme>(() => {
  return {
    letterCardOption: {
      cursor: 'pointer',
      margin: '5px 5px 0 0',
      width: '45px'
    },
    disabled: {
      cursor: 'not-allowed'
    },
    letterCardSelectionBox: {
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(2),
      textAlign: 'center'
    },
    codeLetterContainer: {
      width: '45px !important',
      height: '45px !important',
      border: '2px solid #359BE0',
      borderRadius: '8px'
    },
    letterCardSelectionImage: {
      margin: 'auto',
      overflow: 'hidden',
      width: '45px'
    },
    rowItem: {
      paddingBottom: '0px !important'
    }
  };
});

export interface LetterCardSelectProps {
  onChange?: (value: string) => void;
  error?: string;
  onSecretCodeClear?: () => void;
  disabled?: boolean;
  displayDirection?: 'column' | 'row';
  secretCode?: string;
  hideTitles?: boolean;
  SecretCodeTitle?: React.ReactElement;
  LettercardsTitle?: React.ReactElement;
}

const LetterCardSelect: React.FC<LetterCardSelectProps> = ({
  onChange,
  disabled,
  displayDirection = 'row',
  secretCode = '',
  error,
  SecretCodeTitle,
  LettercardsTitle
}) => {
  const classes = useStyles();

  const handleElementSelect: React.MouseEventHandler<HTMLImageElement> = e => {
    if (secretCode.length < MAX_SECRET_CODE_WIDTH && onChange) {
      onChange(secretCode.concat(e.currentTarget.alt));
    }
  };

  return (
    <div>
      <Grid container direction={displayDirection}>
        <Grid item xs={7} className={classes.letterSelectContiner}>
          {LettercardsTitle || null}
          <Grid container spacing={2}>
            {getLettercardRow(LETTERS, classes, disabled, handleElementSelect)}
          </Grid>
          <Grid container spacing={2}>
            {getLettercardRow(NUMBERS, classes, disabled, handleElementSelect)}
          </Grid>
        </Grid>
        <Grid item xs={5} className={classes.selectedLetterContainer}>
          {SecretCodeTitle || null}
          <Grid container spacing={2}>
            {getSecretCode(classes, secretCode)}
          </Grid>
          {error && (
            <Typography variant="subtitle2" color="primary">
              {error}
            </Typography>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default LetterCardSelect;
